import { render, staticRenderFns } from "./BatchCancelShops.vue?vue&type=template&id=3f25bb06"
import script from "./BatchCancelShops.vue?vue&type=script&lang=ts"
export * from "./BatchCancelShops.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports